<template>
  <div class="container mt-4">
    <h1>Metrics</h1>
    <ul>
      <li v-for="metric in Object.keys(metrics)" :key="metric">
        <template v-if="metric != 'emails'">
          {{ metric }}: {{ metrics[metric] }}
        </template>
        <template v-else>
          <li>emails (scroll)</li>
          <div class="email-container mt-2">
            <ul>
              <li v-for="email in metrics[metric]" :key="email">{{ email }}</li>
            </ul>
          </div>
        </template>
      </li>
    </ul>
  </div>
</template>

<script>
import axios from 'axios'

const backendUrl = process.env.VUE_APP_BACKEND_ROOT

export default {
  data () {
    return {
      metrics: {
        events: 0,
        hosts: 0,
        users: 0,
        emails: []
      }
    }
  },
  methods: {
    fetchMetrics () {
      axios.get(backendUrl + '/admin/metrics')
        .then(resp => {
          this.metrics = Object.assign({}, resp.data)
        })
    }
  },
  created () {
    this.fetchMetrics()
  }
}
</script>

<style scoped>
.email-container {
  height: 250px;
  overflow-y: scroll;
}

li {
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
}
</style>
